import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { EventStats } from '@/features/desktop/types/event-stats';

export const getOnsiteStatsAll = (eventId: number): Promise<EventStats[]> => {
  return axios.get(`/${eventId}/onsite/stats/all`);
};

type QueryFnType = typeof getOnsiteStatsAll;

type UseOptions = {
  eventId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useOnsiteStatsAll = ({ eventId, config }: UseOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['onsite_stats_all', `${eventId}`],
    queryFn: () => getOnsiteStatsAll(eventId),
    ...config,
  });
};
